import { ChannelOutput } from 'js/model/rainbow/content/ChannelOutput';
import { CmsVenueReviewsPage } from 'js/model/cms/cms-venue-reviews-page';
import { formatAddressInline } from 'js/helpers/formatters';
import { PropsType } from 'js/types/react';
import { VenueReviewsDetails } from 'js/model/rainbow/venue-reviews-page/VenueReviewsDetails';
import { Breadcrumb } from 'js/model/rainbow/Breadcrumb';
import { Header } from 'js/pages/VenueReviewsPage/Header';

export function createHeaderViewModel(
  channel: ChannelOutput,
  cms: CmsVenueReviewsPage,
  venueDetails: VenueReviewsDetails,
  breadcrumbs: Breadcrumb[],
  generateUri: (pageType: string, values: object) => string
): PropsType<typeof Header> {
  const formattedAddress = formatAddressInline(
    venueDetails.address.addressLines,
    venueDetails.address.postalCode,
    channel.code
  );

  return {
    bookCta: {
      label: cms.page['venue-reviews']['book-cta'],
      uri: generateUri('venue', {
        normalisedName: venueDetails.normalisedName,
      }),
    },
    breadcrumbs: breadcrumbs.map((breadcrumb) => ({
      name: breadcrumb.name,
      uri: breadcrumb.uri.desktopUri,
    })),
    venueAddress: formattedAddress === null ? '' : formattedAddress,
    venueReviewsTitle: cms.page['venue-reviews'].title.replace(
      '{venueName}',
      venueDetails.name
    ),
  };
}
